<template>
    <common-modal width="huge">
        <common-content-spacer height="medium">
            <common-page-header size="medium" :heading="customReminder.reminderName" :isCenter="true"></common-page-header>
            <div>
                <common-table>
                    <thead>
                        <tr>
                            <th>{{ `${$t('pages.company.custom_reminders.totalPrice')} ${statisticCurrency}` }}</th>
                            <th>{{ ` ${$t('pages.company.custom_reminders.totalSmsPrice')} ${statisticCurrency}` }}</th>
                            <th>{{ $t('pages.company.custom_reminders.totalSmsCount') }}</th>
                            <th>{{ `${$t('pages.company.custom_reminders.totalEmailPrice')} ${statisticCurrency}` }}</th>
                            <th>{{ $t('pages.company.custom_reminders.totalEmailCount') }}</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td :data-label="`${$t('pages.company.custom_reminders.totalPrice')} ${statisticCurrency}`">
                                {{ usageStatistic[0].totalPrice }}
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.totalSmsPrice')">
                                {{ usageStatistic[0].totalSmsPrice }}
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.totalSmsCount')">
                                {{ usageStatistic[0].totalSmsCount }}
                            </td>
                            <td :data-label="`${$t('pages.company.custom_reminders.totalEmailPrice')} ${statisticCurrency}`">
                                {{ usageStatistic[0].totalEmailPrice }}
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.totalEmailCount')">
                                {{ usageStatistic[0].totalEmailCount }}
                            </td>
                        </tr>
                    </tbody>
                </common-table>
            </div>
            <p v-if="showPriceRSD">* {{ $t('pages.company.custom_reminders.pdv_message') }}</p>
            <common-buttons>
                <common-button
                    type="secondary"
                    :isSubmittable="false"
                    :isProcessing="false"
                    :label="$t('common.microcopy.back')"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    export default {
        props: {
            customReminder: { type: Array, default: () => [] },
            usageStatistic: { type: Array, default: () => [] },
            statisticCurrency: { type: String, required: true },
            showPriceRSD: { type: Boolean, default: true },
        },

        computed: {
            heading() {
                return this.companies?.length
                    ? this.$t('layouts.app.main_menu.my_companies')
                    : this.$t('forms.company.create_company.no_companies')
            },
        },
    }
</script>
